import classNames from "classnames";
import pluralize from "pluralize";

import {Service, ServiceDefinition} from "@/lib/types/checks.ts";
import {expirationTimeCSSClass} from "@/pages/dashboard/display/dashboardUtils.ts";

import styles from "@/pages/dashboard/display/components/CheckCard.module.scss";

export const CheckResponseExpirationTime = ({
  service,
  serviceDefinition,
}: {
  service: Service;
  serviceDefinition: ServiceDefinition;
}) => (
  <>
    <div className={styles.checkCardStatName}>{serviceDefinition.performance_data_type_display}</div>
    <div
      className={classNames(
        styles.checkCardStatValue,
        expirationTimeCSSClass(service.cached_response_time, service.msp_threshold)
      )}
    >
      {pluralize("day", Math.floor(Number(service.cached_response_time)), true)}
    </div>
  </>
);
